// extracted by mini-css-extract-plugin
export default {"movie__subtitle":"MovieSubtitle_movie__subtitle__s-q2g"};